<template>
    <div class="modal fade" id="subscriptionModal" tabindex="-1" role="dialog" aria-labelledby="subscriptionModalTitle" aria-hidden="true" ref="modal">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="subscriptionModalTitle">Subscription</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <ul v-if="$store.state.user != null" class="list-group">
                        <li class="list-group-item">Name: {{ $store.state.user.name }}</li>
                        <li class="list-group-item">Email: {{ $store.state.user.email }}</li>
                        <li class="list-group-item">Plan: {{ $store.state.user.planName }}</li>
                        <li class="list-group-item">Months accessable: {{ $store.state.user.numMonths }}</li>
                        <li class="list-group-item">Expires: {{ $store.state.user.expDate }}</li>
                    </ul>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
                    <a class="btn btn-secondary" href="mailto:support@extendweather.com?subject=Subscription">Contact support</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from '@/lib/JQuery.js'

export default {
    name: 'SubscriptionDialog',
    methods: {
        show() {
            $(this.$refs.modal).modal('show')
        }
    }
}
</script>

<style>

</style>
